import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Diagnose from '../views/Diagnose.vue'
import Habits from '../views/Habits.vue'
import FoodDetails from '../views/FoodDetails.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '嘌呤查询',
      content: {
        keywords: '食物 嘌呤查询 痛风 ',
        description: '高血尿酸症俗称痛风，需要长期饮食控制，此网站提供各食物嘌呤含量查询，科学地自我控制'
      }
    }
  },
  {
    path: '/diagnose',
    name: 'Diagnose',
    component: Diagnose,
    meta: {
      title: '痛风诊断'
    }
  },
  {
    path: '/habits',
    name: 'Habits',
    component: Habits,
    meta: {
      title: '生活习惯检查'
    }
  },
  {
    path: '/fooddetails',
    name: 'FoodDetails',
    component: FoodDetails,
    meta: {
      title: '食物详情'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
